/* This array should contain all routes that are part of
 ** the app. Navigation to any of these routes will be
 ** handled by pushState. Otherwise, a regular <a href /> will be used.
 */
const routes = ["/app/pricing", "/pricing", "/downgrade"];
export default routes;
